import type { FC, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xing-com/button';
import { GridItem } from '@xing-com/grid';
import { IconArrowRight } from '@xing-com/icons';
import { CenterContainer } from '@xing-com/platform-layout-view-wrapper';
import { Headline, Meta } from '@xing-com/typography';

import * as Styled from './section-container.styled';

type SectionContainerProps = {
  title: string;
  subtitle?: string;
  linkDisplayText?: string;
  linkUri?: string;
};

export const SectionContainer: FC<PropsWithChildren<SectionContainerProps>> = ({
  title,
  subtitle,
  linkDisplayText = 'CP_SHOW_ALL',
  linkUri,
  children,
  ...props
}) => {
  return (
    <CenterContainer>
      <Styled.SectionGridContainer variant="FullSize" {...props}>
        <Styled.HeaderContainer span={12} spanLarge={10}>
          <Headline noMargin size="xxlarge" sizeConfined="xxxlarge">
            <FormattedMessage id={title} />
          </Headline>
          {subtitle && (
            <Meta noMargin size="large">
              <FormattedMessage id={subtitle} />
            </Meta>
          )}
        </Styled.HeaderContainer>
        {linkUri && (
          <Styled.ButtonContainer span={12} spanLarge={2}>
            <TextButton
              fontWeight="regular"
              icon={IconArrowRight}
              iconAfter
              size="large"
              to={linkUri}
            >
              <FormattedMessage id={linkDisplayText} />
            </TextButton>
          </Styled.ButtonContainer>
        )}
        <GridItem span={12}>{children}</GridItem>
      </Styled.SectionGridContainer>
    </CenterContainer>
  );
};
